export default __webpack_public_path__ + "static/media/requests_active.3c61728c.svg";